import { useMemo, useState } from "react";
import { galleryCategories, galleryItems } from "@/mocks/nanny";

export default function Gallery() {
  const [active, setActive] = useState("all");

  const items = useMemo(
    () => (active === "all" ? galleryItems : galleryItems.filter((g) => g.category === active)),
    [active],
  );

  return (
    <section id="gallery" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
            <div>
              <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Stills</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">精彩剧照</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed">
              作品大多在自然光下拍摄，用柔和的色调承载日常的情绪。以下为部分场景剧照。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
            {galleryCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActive(cat.id)}
                className={`px-4 py-2 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  active === cat.id
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-100 text-foreground-700 border border-background-200 hover:border-foreground-300"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {items.map((item) => (
              <figure
                key={item.id}
                className="group rounded-lg overflow-hidden border border-background-200 bg-background-100 hover:border-primary-300 transition-colors"
              >
                <div className="w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={item.image}
                    alt={`《漂亮的保姆》剧照—${item.title}`}
                    title={`漂亮的保姆 ${item.title} 剧照`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <figcaption className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-foreground-600 text-xs md:text-sm leading-relaxed">{item.desc}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}